import {
  AUTH_STATE_SUBSCRIBE,
  AUTH_STATE_PUBLISH,
  AUTH_STATE_FAILURE,
  AUTH_STATE_UNSUBSCRIBE,
  AUTH_SIGNIN_REQUEST,
  AUTH_SIGNIN_FAILURE,
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNOUT_REQUEST,
  AUTH_SIGNOUT_FAILURE,
  AUTH_SIGNOUT_SUCCESS,
  AUTH_USER_PROFILE_SUBSCRIBE,
  AUTH_USER_PROFILE_PUBLISH,
  AUTH_USER_PROFILE_PUBLISH_BLANK,
  AUTH_USER_PROFILE_UNSUBSCRIBE,
} from '../actionTypes';

const INITIAL_STATE = {
  isFetched: false,
  isAuthenticated: false,
  authError: {},
};

export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH_STATE_SUBSCRIBE:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case AUTH_STATE_PUBLISH:
      return {
        ...state,
        isFetched: true,
        isAuthenticated: !!action.user,
        currentUser: action.user || null,
      };
    case AUTH_STATE_FAILURE:
      return {
        ...state,
        isFetched: true,
        authError: action.error,
      };
    case AUTH_STATE_UNSUBSCRIBE:
      return {
        ...state,
        isFetching: false,
      };
    case AUTH_SIGNIN_REQUEST:
      return {
        ...state,
        signingIn: true,
        authError: {},
      };
    case AUTH_SIGNIN_SUCCESS:
      return {
        ...state,
        signingIn: false,
        authError: {},
      };
    case AUTH_SIGNIN_FAILURE:
      return {
        ...state,
        signingIn: false,
        authError: action.error,
      };
    case AUTH_SIGNOUT_REQUEST:
      return {
        ...state,
        signingOut: true,
        authError: {},
      };
    case AUTH_SIGNOUT_SUCCESS:
      return {
        ...state,
        signingOut: false,
        authError: {},
      };
    case AUTH_SIGNOUT_FAILURE:
      return {
        ...state,
        signingOut: false,
        authError: action.error,
      };
    case AUTH_USER_PROFILE_SUBSCRIBE:
      return {
        ...state,
        isFetchingProfile: true,
      };
    case AUTH_USER_PROFILE_PUBLISH:
      return {
        ...state,
        isFetchingProfile: false,
        currentUser: {
          ...state.currentUser,
          client: action.userProfile.client || null,
          rule: action.userProfile.rule || null,
          fleet: action.userProfile.fleet || null,
        },
        currentProfile: {
          firstName: action.userProfile.firstName || null,
          surname: action.userProfile.surname || null,
          username: action.userProfile.username || null,
        },
      };
    case AUTH_USER_PROFILE_PUBLISH_BLANK:
      return {
        ...state,
        isFetchingProfile: false,
        currentUser: (state.currentUser && {
          ...state.currentUser,
          client: null,
          rule: null,
          fleet: null,
        }) || null,
        currentProfile: null,
      };
    case AUTH_USER_PROFILE_UNSUBSCRIBE:
      return {
        ...state,
        isFetchingProfile: false,
        currentUser: (state.currentUser && {
          ...state.currentUser,
          client: null,
          rule: null,
          fleet: null,
        }) || null,
        currentProfile: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Auth/auth.reducer.js